const sounds = {
  namespaced: true,
  state: {
    sound: "default",
    audio: {
      error: null,
      warning: null,
      success: null,
      info: null,
    },
  },
  mutations: {
    setSound(state, payload) {
      state.sound = payload;
    },
    setAudio(state, payload) {
      state.audio = payload;
    },
  },
  actions: {},
  getters: {},
};

export default sounds;
